let serverClock: { at: number; elapsed: number } | undefined;

// 仅供服务时间展示使用，不参与预约校验或写入。
export function syncServiceDisplayClock(dateHeader: string | null) {
  const at = dateHeader ? Date.parse(dateHeader) : NaN;
  if (Number.isFinite(at)) serverClock = { at, elapsed: performance.now() };
}

const beijingTime = (at: Date) => new Date(at.getTime() + 8 * 3_600_000);

export function serviceTime(value?: string, now?: Date): string {
  if (!value) return "—";
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return "—";
  if (!/(?:Z|[+-][0-9]{2}:?[0-9]{2})$/i.test(value.trim())) return value;
  const current = now ?? (serverClock ? new Date(serverClock.at + performance.now() - serverClock.elapsed) : undefined);
  if (current && !Number.isNaN(current.getTime())) {
    const service = beijingTime(at), reference = beijingTime(current);
    const day = Date.UTC(service.getUTCFullYear(), service.getUTCMonth(), service.getUTCDate());
    const today = Date.UTC(reference.getUTCFullYear(), reference.getUTCMonth(), reference.getUTCDate());
    const offset = (day - today) / 86_400_000;
    if (offset >= 0 && offset <= 2) {
      const pad = (part: number) => String(part).padStart(2, "0");
      return `${["今天", "明天", "后天"][offset]}${pad(service.getUTCHours())}:${pad(service.getUTCMinutes())}`;
    }
  }
  return at.toLocaleString("zh-CN", { timeZone: "Asia/Shanghai", hour12: false });
}
